import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { url_205 } from "../../../../../../../custom_utilities/api_services";
import useAuthUtils from "../../../../../../../hooks/auth/useAuthUtils";

export const useGetPyqChallengeList = () => {
  const { startLoading, finishLoading } = useAuthUtils();

  const fetchPyqChallengeList = async () => {
    try {
      startLoading();
      const response = await axios.post(url_205);

      if (response.data.status === 200) {
        console.log("reponse of challenge", response.data.data);
        return response?.data?.data;
      }
      return [];
    } catch (error) {
      console.log(error);
      return [];
    } finally {
      finishLoading();
    }
  };

  return useQuery({
    queryKey: ["pyq-challenge-list"],
    queryFn: fetchPyqChallengeList,
  });
};
